import BaseApi from './BaseApi';

export interface IDocumentTemplates {
    get(clientNumber: number, projectNumber: number, jwt: string): Promise<object>;
    getFromProject(clientNumber: number, projectNumber: number, jwt: string): Promise<object>;
    attach(clientNumber: number, projectNumber: number, documentTemplateIds: Array<number>, jwt: string): Promise<object>;
    remove(clientNumber: number, projectNumber: number, attachedIds: Array<number>, jwt: string): Promise<object>;
}

export default class DocumentTemplates extends BaseApi implements IDocumentTemplates {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    get = (clientNumber: number, projectNumber: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/documentTemplate`, jwt);
    };

    getFromProject = (clientNumber: number, projectNumber: number, jwt: string): Promise<object> => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/documentTemplate/by-project/all`, jwt);
    };

    attach = (clientNumber: number, projectNumber: number, documentTemplateIds: number[], jwt: string): Promise<object> => {
        let query = '';
        for (let id of documentTemplateIds) {
            if (query.length > 0) {
                query += `&documentTemplateIds=${id}`;
            } else {
                query += `?documentTemplateIds=${id}`;
            }
        }

        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/documentTemplate${query}`,
            undefined,
            jwt
        );
    };

    remove = (clientNumber: number, projectNumber: number, attachedIds: number[], jwt: string): Promise<object> => {
        let query = '';
        for (let id of attachedIds) {
            if (query.length > 0) {
                query += `&removeIds=${id}`;
            } else {
                query += `?removeIds=${id}`;
            }
        }

        return this.deleteRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/documentTemplate${query}`,
            undefined,
            jwt
        );
    };
}


// WEBPACK FOOTER //
// ./src/api/DocumentTemplates.ts